<template>
  <div :class="$style.page">
    <Loading :loading="loading" text="">
      <Title title="域名订单" />
      <Item title="状态" :class="$style.item">
        <template v-for="(item, index) in statusList">
          <Button
            :type="status === item.value ? 'primary' : ''"
            round
            :key="index"
            @click="selectStatus(item.value)"
          >
            {{ item.name }}
          </Button>
        </template>
      </Item>

      <Item title="创建时间" :class="$style.item">
        <el-date-picker
          v-model="startTime"
          type="date"
          placeholder="选择日期"
        />
        <el-date-picker v-model="endTime" type="date" placeholder="选择日期" />
        <Button type="primary" @click="searchData(1)">搜索</Button>
      </Item>

      <Divider />

      <Title title="搜索结果" :count="total" />

      <!-- 搜索结果列表 -->
      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="name" label="序号" width="30" align="center">
          <template slot-scope="scope">{{
            limit * (page - 1) + scope.$index + 1
          }}</template>
        </el-table-column>

        <el-table-column
          prop="orderNum"
          label="订单号"
          width="120"
          align="center"
        />

        <el-table-column prop="id" label="产品名称" width="120" align="center">
          <template slot-scope="scope">{{
            scope.row.domainNameList[0]
          }}</template>
        </el-table-column>

        <el-table-column
          prop="createdTime"
          label="创建时间"
          width="90"
          align="center"
        />

        <el-table-column label="订单金额" width="50" align="center">
          <template slot-scope="scope">
            <span class="theme-color">{{ scope.row.amount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="50" align="center">
          <template slot-scope="scope">
            {{ mapStatus[scope.row.state] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="$style.btn_actions">
              <span
                v-if="scope.row.state === 0"
                @click="toPay(scope.row.orderNum)"
              >
                付款
              </span>
              <span
                v-if="scope.row.state === 0"
                @click="toCancel(scope.row.orderNum)"
              >
                取消
              </span>
              <span @click="toDetail(scope.row.orderNum)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </Loading>
  </div>
</template>

<script>
import { getOrderList, deleteOrder } from "@server";
import { ORDER_STATUS, MAP_ORDER_STATUS } from "@constant";

export default {
  name: "DomainOrder",
  data() {
    return {
      statusList: ORDER_STATUS,
      status: -1,
      mapStatus: MAP_ORDER_STATUS,

      startTime: "",
      endTime: "",

      page: 1,
      limit: 50,
      loading: false,
      showList: [], //展示列表
      total: 0, //总数
    };
  },
  methods: {
    selectStatus(value) {
      this.status = value;
      this.searchData();
    },

    async searchData(page = 1) {
      this.loading = true;
      this.page = page;

      const params = {
        page,
        limit: this.limit,
      };
      this.status !== -1 && (params.state = this.status);
      this.startTime && (params.startCreatedTime = this.startTime);
      this.endTime && (params.endCreatedTime = this.endTime);
      const res = await getOrderList(params);
      const { code, data } = res;

      if (code === 200) {
        this.total = data.total;
        this.showList = data.list;
      }

      this.loading = false;
    },

    toPay(orderNo) {
      this.$router.push(`/cart?orderNo=${orderNo}`);
    },

    async toCancel(orderNo) {
      const res = await deleteOrder({ orderNo: orderNo });

      if (res.code === 200) {
        this.$message({ message: "订单取消成功", type: "success" });
        this.searchData();
      } else {
        this.$message({ message: "订单取消失败", type: "error" });
      }
    },

    toDetail(orderNo) {
      this.$router.push(`/user/order-detail?orderNo=${orderNo}`);
    },

    handlePageChange(page) {
      this.searchData(page);
    },
  },
  created() {
    this.searchData();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: 0 rem(50);
  background: $white;
  box-shadow: $box-shadow;

  ::v-deep .item {
    display: flex;
    margin-bottom: rem(40);

    :global {
      .gl-item__left {
        width: rem(80);
        padding-right: 30px;
        font-size: 14px;
        text-align: right;
      }
    }
  }

  :global {
    .el-input {
      width: rem(340);
      margin-right: rem(20);
    }

    .el-pagination {
      margin: rem(50) 0;
      @include flex();
    }
  }

  .btn_actions {
    @include flex();
    gap: 10px;

    > span {
      font-size: rem(14);
      color: $theme-color;
      cursor: pointer;
    }
  }
}
</style>
